module.exports = __webpack_public_path__ + "static/media/chevron-circle-down.bde5a821.svg";